import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b85bbea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-BG" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "models explorer models" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "model-info" }
const _hoisted_9 = { class: "model-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "model-type" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, " ", -1))
const _hoisted_14 = { class: "model-info" }
const _hoisted_15 = { class: "model-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "model-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModelTags = _resolveComponent("ModelTags")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (model) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "model",
            onClick: ($event: any) => (_ctx.$router.push(_ctx.getModelUrl(model.type)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (
								_ctx.loadedAssets[model.filename] &&
								model.media === 'video'
							)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 0,
                    src: _ctx.loadedAssets[model.filename],
                    autoplay: "",
                    loop: "",
                    muted: "",
                    playsinline: ""
                  }, null, 8, _hoisted_6))
                : (_ctx.loadedAssets[model.filename])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.loadedAssets[model.filename],
                      class: "model-image"
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.getModelTitle(model.type)), 1),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(model.type), 1)
            ]),
            _createVNode(_component_ModelTags, { model: model }, null, 8, ["model"])
          ], 8, _hoisted_4))
        }), 256)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.utilityModels, (type) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "model",
            onClick: ($event: any) => (_ctx.$router.push(_ctx.getModelUrl(type)))
          }, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.getModelTitle(type)), 1),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(type), 1)
            ]),
            _createVNode(_component_ModelTags, {
              model: { type }
            }, null, 8, ["model"])
          ], 8, _hoisted_12))
        }), 256))
      ])
    ])
  ]))
}